module.exports = __webpack_public_path__ + "img/Nutanix_Logo_blue.08e4b980.png";